"use client";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { Accordion } from "flowbite-react";
import data from "../../graph_data";
import { Doughnut, Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function DefaultAccordion() {
  return (
    <Accordion className="w-full">
      <Accordion.Panel>
        <Accordion.Title>Heating</Accordion.Title>
        <Accordion.Content>
          <ul className="p-[20px] text-gray-500 dark:text-gray-400 list-disc">
            <li className="mb-5 w-full">
              <p>What type of energy are you using for heating ?</p>

              <div id="hp-part-1" className="flex flex-col gap-5 items-center w-[700px] justify-center mx-auto">
                <div className="w-[250px]">
                  <Doughnut
                    data={data["Heating"].chart_data}
                    options={data["Heating"].options}
                  />
                </div>

                <span>
                  Our survey is in accordance within Insee data showing that 40%
                  of the energy used for heating is gas.[1] It also confirms
                  that most of the heating comes from the burning fossil fuels
                  which highly contribute to global warming. [2] This reinforce
                  our idea that finding a new eco-friendly heating system could
                  be impactful for the society.
                </span>
              </div>
            </li>
            <li className="mb-5">
              <p className="pt-[20px]">
                How satisfied are you with your current heating system ?
              </p>

              <div id="hp-part-1" className="flex flex-col gap-5 items-center w-[700px] justify-center mx-auto">
                <span>
                  People have declared being statisfied of their heating system
                  at a grade of 3.48 out of 5.
                </span>
              </div>
            </li>
            <li className="mb-5">
              <p>What are the biggest issues related to your heating system?</p>
              <div id="hp-part-1" className="flex flex-col gap-5 items-center w-[700px] justify-center mx-auto">
                <Bar
                  options={data["Issues"].options}
                  data={data["Issues"].chart_data}
                />
                <span>
                  In first position comes the cost while the environmental
                  impact was mainly ranked at the second position. Together they
                  represent more than 700% of the answers for the most imporant
                  inconvenient meaning that by founding an eco-friendly and more
                  cost effective solution, we will address the biggest issues
                  related to heating.
                </span>
              </div>
            </li>
            <li>
              <p className="pt-[20px]">
                If you would change your heating system, which criteria would
                you look for in first ?
              </p>

              <div id="hp-part-1" className="flex flex-col gap-5 items-center w-[700px] mx-auto">
                <Bar
                  options={data["NewHeating"].options}
                  data={data["NewHeating"].chart_data}
                />

                <span>
                  Cost, Environmental impact and efficiency are 96% of the
                  answers found in first position. By paying attention to these
                  criteria in the development of our project we will attract
                  most of the population. Even though it should be taken in
                  account, system maintenance doesn’t need to be our priority.
                  In light of this survey, we identified our two main point of
                  actions : the cost and the environmental impact. This leads us
                  to realise a study of cost and to assess the carbon footprint
                  of our project to check if we are really adressing the issues
                </span>
              </div>
            </li>
          </ul>
        </Accordion.Content>
      </Accordion.Panel>
      <Accordion.Panel>
        <Accordion.Title>EE2 pollution</Accordion.Title>
        <Accordion.Content>
          <ul className="p-[20px] text-gray-500 dark:text-gray-400 list-disc">
            <li className="mb-5 w-full">
              <p>
                Are you aware of the estrogen pollution in water and the
                presence of potential toxic molecules in tap water ?
              </p>

              <div id="hp-part-1" className="flex flex-col gap-5 items-center w-[700px] justify-center mx-auto">
                <div className="w-[250px]">
                  <Doughnut
                    data={data["Awareness"].chart_data}
                    options={data["Awareness"].options}
                  />
                </div>

                <span>
                  More than a third of the population have declared not being
                  aware, or not being sure to be aware , of the presence of
                  endocrine disruptors, called EE2, in tap water. It shows the
                  importance to do sensibilization and inform. This result has
                  guided us in our communcation on our social media where we did
                  post about this subject and also lead us to do a conference
                  about endocrine disruptors in our university.
                </span>
                <span>
                  According to the survey, people are worried by the presence of
                  EE2 at an average level of 3.84 out of 5.
                </span>
              </div>
            </li>
          </ul>
        </Accordion.Content>
      </Accordion.Panel>
      <Accordion.Panel>
        <Accordion.Title>About Clean Heat</Accordion.Title>
        <Accordion.Content>
          <ul>
            <li className="mb-5 w-full">
              <p>
                For this last section, we wanted to know the opinion and how our
                project was percieved by the population. The three following
                questions were asked :
              </p>
              <ul>
                <li>- Would you accept to use heat from Clean Heat if it is implemented as urban heat ? (Left)</li>
                <li>- Is it a problem for you that Clean Heat contains GMOs if there are securities which ensure to keep GMOs strictly inside the bioreactor ? (Middle)</li>
                <li>- Do you believe in Clean Heat as a greener and more economic source of heat ? (Right)</li>
              </ul>

              <div id="hp-part-1" className="flex flex-col gap-5 items-center w-[700px] justify-center mx-auto">
                <div className="flex gap-20">
                  {data["CleanHeat"].chart_data.map((elt: any, idx: any) => {
                    return (
                      <div id="hp-part-2" className="w-[250px]">
                        <Doughnut
                          data={elt}
                          options={data["CleanHeat"].options}
                          key={idx}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </li>
          </ul>
        </Accordion.Content>
      </Accordion.Panel>
    </Accordion>
  );
}
